/**
 * Normaliza el RUT para envío al API: sin puntos ni guión; DV en minúscula si es k.
 */
export function normalizeRutForApi(raw) {
  const cleaned = String(raw ?? "")
    .replace(/\./g, "")
    .replace(/-/g, "")
    .replace(/\s/g, "")
    .replace(/[^0-9kK]/g, "");
  if (cleaned.length < 2) return "";
  const body = cleaned.slice(0, -1);
  const dv = cleaned.slice(-1).toLowerCase();
  return `${body}${dv}`;
}
